var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.05,
    height: 12.75,
    viewBox: "0 0 11.05 12.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05.22A.75.75,0,0,0,5,.22L.22,5a.75.75,0,0,0,0,1.06.74.74,0,0,0,1.06,0L5.52,1.81,9.77,6.05a.74.74,0,0,0,1.06,0,.75.75,0,0,0,0-1.06Zm.22,12.53V.75H4.77v12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortUp);
export default __webpack_public_path__ + "static/media/icon-sort-up.d96f5a429f73fc187193de7613a5ce2a.svg";
export { ForwardRef as ReactComponent };